import type { IAddress } from '@/types/address';
import type { MissionStatus } from '@/types/mission';

export interface FetchMissionsParams {
	clientId: string | string[];
	mode: string;
	missionStatus: MissionStatus[];
	noPagination: boolean;
}

export enum SynchronizeFieldType {
	ACTIVE_PROPOSAL_STATUS = 'activeProposalStatus',
	ROLE = 'role',
	PHONE = 'phone',
	OTHER = 'other',
}

export interface SearchCompaniesParams {
	q: string;
	limit?: number;
	agencyId?: string;
}

export interface SearchCompaniesResult {
	id: string;
	name: string;
	createdAt: Date | null;
	updatedAt: Date | null;
	description: string | null;
	siret: string | null;
	nafCode: string | null;
	agencyNote: string | null;
	addressStreet: string | null;
	addressCity: string | null;
	addressZip: string | null;
	addressDepartment: string | null;
	addressLatitude: number | null;
	addressLongitude: number | null;
	phone: string | null;
	email: string | null;
	businessSectorId: string | null;
	businessSectorName: string | null;
	evoliaId: string | null;
	ownerAgencyId: string | null;
	responsibleId: string | null;
	responsibleName: string | null;
	lastMissionDate: Date | null;
	besoinArchivedCount: number;
}

export interface SearchCompaniesResponse {
	items: SearchCompaniesResult[];
	total: number;
}

export interface FetchCompanyAddressResponse {
	id: string;
	createdAt: string | null;
	updatedAt: string | null;
	companyId: string | null;
	name: string | null;
	street: string | null;
	complement: string | null;
	city: string | null;
	zip: string | null;
	department: string | null;
	region: string | null;
	countryCode: string | null;
	inseeCode: string | null;
	latitude: number | null;
	longitude: number | null;
	isMain: boolean;
	evoliaOrder: number | null;
}

export type CompanyAddress = IAddress & { id?: string };

export interface AddCompanyContactResponse {
	id: string;
	companyId: string;
	fullName: string;
	email: string;
	role: string;
}

export interface AddCompanyAddressResponse {
	id: string;
	companyId: string;
	addressId: string;
	isMain: boolean;
}
